import React, { useEffect, useState } from "react";
import "./index.css";
import Header from "../../../common/Header";
import { Table, Space, Modal } from "antd";
import ApiService from "../../../../Service/ApiService";
import { DeleteTwoTone, EditTwoTone } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const ViewHotels = () => {
  const [hotels, setHotels] = useState([]);
  const [admins, setAdmins] = useState([]);
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedHotel, setSelectedHotel] = useState();

  const fetchHotels = async () => {
    try {
      const users = await ApiService.getUsersByRole("ADMIN");
      const hotels = await ApiService.fetchHotels();

      setAdmins(users || []);
      setHotels(Array.isArray(hotels) ? hotels : hotels?.data || []);
      
    } catch (error) {
      console.error("Fetch hotels failed", error);
      setAdmins([]);
      setHotels([]);
    }
  };

  useEffect(() => {
    fetchHotels();
  }, []);

  const editHotel = (record) => {
    navigate("/admin/hotels/edit", { state: { hotel: record } });
  };

  const openDeleteModal = (record) => {
    setSelectedHotel(record);
    setModalOpen(true);
  };

  const closeDeleteModal = () => {
    setModalOpen(false);
  };

  const handleHotelDelete = async () => {
    if (selectedHotel) {
      const result = await ApiService.deleteHotel(selectedHotel.id);
      if (result) {
        await fetchHotels();
        closeDeleteModal();
      }
    }
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Image",
      dataIndex: "hotelImage",
      key: "hotelImage",
      render: (text) => (
        <img src={text} alt="Hotel" style={{ width: "100px", height: "100px" }} />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Currency",
      dataIndex: "currency",
      key: "currency",
    },
    {
      title: "Manager",
      dataIndex: "manager",
      key: "manager",
      render: (_, record) => {
        if (record.manager) {
          let user = admins.filter((x) => x.id === record.manager);
          if (user.length > 0) {
            return user[0].name;
          }
        }
        return "";
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <EditTwoTone
            twoToneColor="#0000ff"
            style={{ cursor: "pointer", fontSize: "16pt" }}
            onClick={() => editHotel(record)}
          />
          <DeleteTwoTone
            twoToneColor={"#ff0000"}
            style={{ cursor: "pointer", fontSize: "16pt" }}
            onClick={() => openDeleteModal(record)}
          />
        </Space>
      ),
    },
  ];
  return (
    <div className="default-container">
      <Header title={"View and Manage Hotels"} />
      <div className="action-buttons">
        <button
          type="primary"
          className="add-room-button"
          size={"large"}
          onClick={() => navigate("/admin/hotels/edit")}
        >
          Create Hotel
        </button>
      </div>
      <Table dataSource={hotels} columns={columns} rowKey={"id"} />
      <Modal
        title="Delete Hotel?"
        open={modalOpen}
        centered
        onOk={() => handleHotelDelete()}
        onCancel={() => closeDeleteModal()}
      >
        <p>
          Delete this hotel? All it's associated rooms and bookings will be
          deleted.
        </p>
      </Modal>
    </div>
  );
};

export default ViewHotels;
